/* GoogleMaps.js */

export const loadGoogleMaps = (callback) => {
    let existingScript = document.getElementById('googleMaps');

    if(!existingScript){
        var scripts = document.getElementsByTagName("script")
        for (var i = 0; i < scripts?.length; ++i) {        
            if(scripts[i]?.src?.includes("https://maps.googleapis.com/maps")){            
                existingScript=true
            }    
        }
    }

    if (!existingScript) {
        const script = document.createElement('script');
        const apikey= process.env.REACT_APP_GMAPS_TOKEN
        script.src = 'https://maps.googleapis.com/maps/api/js?key='+apikey
        script.id = 'googleMaps';
        script.async = true;
        script.defer = true;        
        document.body.appendChild(script);

        script.onload = () => {
            if (callback) callback();
        };
    }

    if (existingScript && callback) callback();
};

export const removeGoogleMaps = () => {
    let mapScript = document.getElementById('googleMaps');   

    if (mapScript) {
       mapScript.parentNode.removeChild(mapScript);
    }

    const head = document.getElementsByTagName('head')[0];
    const scripts = head.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
        let script = scripts[i];
        let src = script.src;

        if (src.startsWith('https://maps.googleapis.com/maps')) {
            head.removeChild(script);
        }
    }   
};
